<template>
    <div class="main-creator">
      <div class="input-area">
        <label for="link-input">链接：</label>
        <input class="link-input"
               type="text"
               ref="linkinputone"
               name="link-input"
               placeholder="输入需要转换的链接">
        <input class="sure-button" type="button" @click="updatePic" value="确认">
        <div class="notes">
          此二维码内容为: {{ qrvalue }} <br>
          <p>Notes: 长按或者鼠标右键保存至本地~</p>
        </div>
      </div>
      <qriously class="codepic" :value=qrvalue :size="200" />
      <div class="clearfix"></div>
    </div>
</template>

<script>
export default {
  name: 'CodeCreator',
  data() {
    return {
      qrvalue: 'https://www.baidu.com',
    };
  },
  methods: {
    updatePic() {
      const newlink = this.$refs.linkinputone.value;
      if (newlink != null && newlink !== '') {
        this.qrvalue = newlink;
      } else {
        this.qrvalue = 'https://cn.bing.com';
      }
    },
  },
};
</script>

<style scoped>
.main-creator {
  margin: 0.5em 2em 0;
}

.main-creator .input-area {
  float: left;
  height: 12.5em;
  width: 50%;
  text-align: center;
}

.main-creator .input-area label {
  font-size: 1em;
  font-weight: bold;
}

.main-creator .input-area .link-input {
  border: 1px solid #438bf4;
  border-radius: 3px;
  height: 1.5em;
  width: 15em;
  margin-right: 1.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.main-creator .input-area .sure-button {
  background-color: #0dbc79;
  color: #fff;
  border: 1px solid #0dbc79;
  border-radius: 2px;
  height: 2.5em;
  width: 4em;
}

.main-creator .input-area .notes {
  margin-top: 1em;
  font-size: 0.8em;
  color: #333e42;
}

.main-creator .codepic {
  float: left;
  width: 50%;
  text-align: center;
}

.clearfix:before,
.clearfix:after {
    content: " ";
    display: table;
}

.clearfix:after {
    clear: both;
}

@media only screen and (min-width: 50em) {

}

@media only screen and (min-width: 30.0625em ) and (max-width: 50em) {
  .main-creator {
    margin: 0.5em 1.2em 0;
  }
  .main-creator .input-area {
      width: 55%;
    }

  .main-creator .input-area .link-input {
    width: 10em;
    margin-right: 1em;
  }
  .main-creator .input-area .sure-button {
    height: 2em;
    width: 3em;
  }

  .main-creator .codepic {
    width: 45%;
  }
}

@media only screen and (max-width: 30.0625em) {
    .main-creator .input-area {
      width: 100%;
      height: 8.5em;
    }

    .main-creator .codepic {
      width: 100%;
    }
}


</style>




// WEBPACK FOOTER //
// src/views/components/Creator.vue